import React, { useState } from "react";
import Layout from "../components/Layout";
import ProductieCumulat from "../components/ProductieCumulat";
import ProductieEvolutiv from "../components/ProductieEvolutiv";

const TABS = [
  ["cumulat", "Cumulat"],
  ["evolutiv", "Raport evolutiv"],
];

export default function Productie() {
  const [tab, setTab] = useState("cumulat");
  return (
    <Layout title="Productie">
      <div data-testid="productie-page">
        <div className="mb-5 flex gap-1 border-b border-slate-200">
          {TABS.map(([k, l]) => (
            <button
              key={k}
              data-testid={`productie-tab-${k}`}
              onClick={() => setTab(k)}
              className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium ${tab === k ? "border-accent-500 text-slate-900" : "border-transparent text-slate-500 hover:text-slate-800"}`}
            >
              {l}
            </button>
          ))}
        </div>
        {tab === "cumulat" && <ProductieCumulat />}
        {tab === "evolutiv" && <ProductieEvolutiv />}
      </div>
    </Layout>
  );
}
